// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"ddbb93b3","555":"41ee6eea","564":"9c3d0edb","573":"e66ac41d","753":"8194fa75","965":"2bb60923"}[chunkId] + ".chunk.js";
};